import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './to.png'


const _withScopeId = n => (_pushScopeId("data-v-076f5d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "codes" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"min-width":"200px"} }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = {
  key: 0,
  class: "status"
}
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正在同步轨迹中，请稍等几分钟再试试", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "error"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运输商暂未更新轨迹或信息有误。", -1))
const _hoisted_15 = { class: "from-to" }
const _hoisted_16 = { class: "from" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_20 = { class: "to" }
const _hoisted_21 = {
  key: 2,
  class: "events"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.Codes ?? [], (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass(`${_ctx.code == item.Code ? 'active' : ''} ${
          item.ParentId ? 'part' : 'main'
        }`),
            onClick: ($event: any) => (_ctx.getTracking(item.Code))
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.Code) + "(" + _toDisplayString(_ctx.statusList.firstOrDefault(
              (s) =>
                s.code ==
                _ctx.detail?.GetTrackInfo?.data?.accepted?.firstOrDefault(
                  (it) => it.number == item.Code
                )?.track_info?.latest_status?.status
            )?.label ?? "查询不到") + ")", 1)
          ], 10, _hoisted_2))
        }), 128))
      ]),
      ((_ctx.detail?.Codes?.length ?? 0) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "status-wrap",
                key: i
              }, [
                (
            item.code == _ctx.tracking?.track_info?.latest_status?.status ||
            (item.code == 'NotFound' && !_ctx.tracking?.track_info)
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("i", {
                        class: _normalizeClass(`icon fa-PS_${item.value}`)
                      }, null, 2),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.code), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(item.label), 1),
                          (_ctx.tracking?.track_info?.time_metrics?.days_after_order)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "（" + _toDisplayString(_ctx.tracking?.track_info?.time_metrics?.days_after_order) + "天）", 1))
                            : _createCommentVNode("", true),
                          (_ctx.codeInfo?.AllDeliveryTime)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 签收时间：" + _toDisplayString(_ctx.codeInfo?.AllDeliveryTime), 1))
                            : (_ctx.codeInfo?.PlanDeliveryTime)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " 预计到达时间：" + _toDisplayString(_ctx.codeInfo?.PlanDeliveryTime), 1))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.rejected?.error?.code == -18019909)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : (!_ctx.provider?.events || _ctx.provider.events.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        href: "javascript:void",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInfo && _ctx.handleInfo(...args)))
                      }, "补充信息")
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, _toDisplayString(_ctx.tracking?.track_info?.shipping_info?.shipper_address?.country ??
              "未知"), 1),
                (_ctx.carrier)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.carrier["_name_zh-cn"] ?? "未知"), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, "未知"))
              ]),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.tracking?.track_info?.shipping_info?.recipient_address?.country ??
            "未知"), 1)
            ]),
            (_ctx.provider?.events && _ctx.provider.events.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provider?.events, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item.time_iso) + " " + _toDisplayString(item.location) + ", " + _toDisplayString(item.description), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (
          _ctx.tracking?.track_info?.misc_info &&
          (_ctx.tracking?.track_info?.misc_info?.local_provider ||
            _ctx.tracking?.track_info?.misc_info?.weight_kg ||
            _ctx.tracking?.track_info?.misc_info?.local_number ||
            _ctx.tracking?.track_info?.misc_info?.dimensions ||
            _ctx.tracking?.track_info?.misc_info?.pieces)
        )
              ? (_openBlock(), _createBlock(_component_miezz_button, {
                  key: 3,
                  model: _ctx.btnMore,
                  onHandleClick: _ctx.handleClick
                }, null, 8, ["model", "onHandleClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalParam,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalParam) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.formParam,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formParam) = $event)),
          ref: "ref-form-param"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalMore,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalMore) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: false,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "尾程派送服务商" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.tracking?.track_info?.misc_info?.local_provider ?? "- -"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "包裹重量" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.tracking?.track_info?.misc_info?.weight_kg
                ? `${_ctx.tracking?.track_info?.misc_info?.weight_kg}kg`
                : "- -"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "尾程单号" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.tracking?.track_info?.misc_info?.local_number ?? "- -"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "包裹体积" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.tracking?.track_info?.misc_info?.dimensions ?? "- -"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  offset: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "物品数量" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.tracking?.track_info?.misc_info?.pieces ?? "- -"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}